import __vue_component__ from './IconNavigationEntranceLarge.vue.js';
import __vue_component__$1 from './IconNavigationEntranceMedium.vue.js';
import __vue_component__$2 from './IconNavigationEntranceSmall.vue.js';

//
var script = {
  name: 'IconNavigationEntrance',
  components: {
    IconNavigationEntranceLarge: __vue_component__,
    IconNavigationEntranceMedium: __vue_component__$1,
    IconNavigationEntranceSmall: __vue_component__$2
  },
  props: {
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    icon() {
      switch (this.size) {
        case 'large':
          return __vue_component__;

        case 'medium':
          return __vue_component__$1;

        case 'small':
          return __vue_component__$2;

        default:
          return __vue_component__$2;
      }
    }
  }
};

export default script;
